import { render, staticRenderFns } from "./LyricModal.vue?vue&type=template&id=18a573ce&"
import script from "./LyricModal.vue?vue&type=script&lang=js&"
export * from "./LyricModal.vue?vue&type=script&lang=js&"
import style0 from "./LyricModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports